import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { createRmParamRelateData, deleteRmParamRelateData as _deleteRmParamRelateData, deleteRmParamRelateDataByIds, updateRmParamRelateData, findRmParamRelateData, getRmParamRelateDataList } from "@/api/rm_param_relate_data"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/data";
import infoList from "@/components/mixins/infoList";
import { getAllRmParamTypeList } from "@/api/rm_param_type";
export default {
  name: "RmParamRelateData",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getRmParamRelateDataList,
      dialogFormVisible: false,
      visible: false,
      dialogTitle: "",
      type: "",
      paramTypeOptions: [],
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        code: null,
        name: null,
        type: null,
        createtime: null,
        showorder: null
      }
    };
  },
  methods: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? this.$t('common.yes') : this.$t('common.no');
      } else {
        return "";
      }
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var ids, res;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      ids = [];
                      _this.multipleSelection && _this.multipleSelection.map(function (item) {
                        ids.push(item.ID);
                      });
                      _context.next = 1;
                      return deleteRmParamRelateDataByIds({
                        ids: ids
                      });
                    case 1:
                      res = _context.sent;
                      if (res.code == 0) {
                        _this.$message({
                          type: 'success',
                          message: _this.$t('common.success')
                        });
                        _this.deleteVisible = false;
                        _this.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))).catch(function () {
                _this.$message({
                  type: "info",
                  message: _this.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function onDelete() {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    updateRmParamRelateData: function () {
      var _updateRmParamRelateData = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return findRmParamRelateData({
                ID: row.ID
              });
            case 1:
              res = _context3.sent;
              this.type = "update";
              if (res.code == 0) {
                this.getParamType();
                this.formData = res.data.rermParamRelateData;
                this.dialogTitle = this.$t('common.edit');
                this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateRmParamRelateData(_x) {
        return _updateRmParamRelateData.apply(this, arguments);
      }
      return updateRmParamRelateData;
    }(),
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        code: null,
        name: null,
        type: null,
        createtime: null,
        showorder: null
      };
    },
    deleteRmParamRelateData: function () {
      var _deleteRmParamRelateData2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var res;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this2.visible = false;
                      _context4.next = 1;
                      return _deleteRmParamRelateData({
                        ID: row.ID
                      });
                    case 1:
                      res = _context4.sent;
                      if (res.code == 0) {
                        _this2.$message({
                          type: "success",
                          message: _this2.$t('common.success')
                        });
                        _this2.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }))).catch(function () {
                _this2.$message({
                  type: "info",
                  message: _this2.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deleteRmParamRelateData(_x2) {
        return _deleteRmParamRelateData2.apply(this, arguments);
      }
      return deleteRmParamRelateData;
    }(),
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _t = this.type;
              _context6.next = _t === "create" ? 1 : _t === "update" ? 3 : 5;
              break;
            case 1:
              _context6.next = 2;
              return createRmParamRelateData(this.formData);
            case 2:
              res = _context6.sent;
              return _context6.abrupt("continue", 7);
            case 3:
              _context6.next = 4;
              return updateRmParamRelateData(this.formData);
            case 4:
              res = _context6.sent;
              return _context6.abrupt("continue", 7);
            case 5:
              _context6.next = 6;
              return createRmParamRelateData(this.formData);
            case 6:
              res = _context6.sent;
              return _context6.abrupt("continue", 7);
            case 7:
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: this.$t('common.success')
                });
                this.closeDialog();
                this.getTableData();
              }
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    openDialog: function openDialog(type) {
      switch (type) {
        case 'create':
          this.dialogTitle = this.$t('common.add');
          this.dialogFormVisible = true;
          break;
        case 'edit':
          this.dialogTitle = this.$t('common.edit');
          this.dialogFormVisible = true;
          break;
        default:
          break;
      }
      this.getParamType();
      this.type = type;
      this.dialogFormVisible = true;
    },
    getParamType: function () {
      var _getParamType = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return getAllRmParamTypeList({});
            case 1:
              res = _context7.sent;
              if (res.code == 0) {
                this.paramTypeOptions = res.data.rmparamtypes;
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getParamType() {
        return _getParamType.apply(this, arguments);
      }
      return getParamType;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 1;
            return this.getTableData();
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};